import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LanguageService } from '@core/i18n/language.service';
import { AppLang } from '@core/i18n/language.tokens';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
  private readonly languageService = inject(LanguageService);

  readonly languages: AppLang[] = ['fa', 'en'];

  current = this.languageService.current;

  isActive(lang: AppLang): boolean {
    return this.current() === lang;
  }

  select(lang: AppLang): void {
    this.languageService.switchWithTranslations(lang);
  }

  isFirst(lang: AppLang): boolean {
    return this.languages.indexOf(lang) === 0;
  }

  isLast(lang: AppLang): boolean {
    return this.languages.indexOf(lang) === this.languages.length - 1;
  }
}
